import axios from "axios"
/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 */
//  import axios from "axios";
//  import store from "@/store/";
//  import router from "@/router/router";
//  import { serialize } from "@/util/util";
//  import { getToken } from "@/util/auth";
//  import { Message } from "element-ui";
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import router from "../router/index"
import { Message, Loading } from 'element-ui'
import { tansParams, blobValidate } from "@/utils/common"
import { saveAs } from 'file-saver'
import errorCode from '@/utils/errorCode'

//默认超时时间
axios.defaults.timeout = 100000000
//返回其他状态码
axios.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 500
}
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true
// NProgress 配置
NProgress.configure({
  // 动画方式
  easing: "ease",
  // 递增进度条的速度
  speed: 500,
  // 是否显示加载ico
  showSpinner: false,
  // 自动递增间隔
  trickleSpeed: 200,
  // 初始化时的最小百分比
  minimum: 0.3
})
//http request拦截
axios.interceptors.request.use(
  config => {
    //开启 progress bar
    if(!config.params || !config.params.disableProgressBar) {
      NProgress.start()
    }


    const meta = config.meta || {}
    const token = localStorage.getItem('token')
    // 代理前缀
    config.baseURL = '/dev-api'
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }

    //headers中配置text请求
    if (config.text === true) {
      config.headers["Content-Type"] = "text/plain"
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params)
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      //  config.data = serialize(config.data);
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)
//http response 拦截
axios.interceptors.response.use(
  res => {

    //关闭 progress bar
    NProgress.done()
    //获取状态码
    const status = res.data.code || res.status
    // const message = res.data.msg || res.data.error_description || "未知错误"
    //如果是401则跳转到登录页面
    if (status === 401) {
      localStorage.clear()
      router.push('/login').catch(()=>{})
      location.href='/login'
      return null
    }

    // 如果请求为非200否者默认统一处理
    // if (status !== 200 && status !== 401) {
    //   return Promise.reject(new Error(message))
    // }
    return res.data
  },

  error => {
    NProgress.done()
    return Promise.reject(new Error(error))
  }
)

// 通用下载方法
let downloadLoadingInstance
export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)" })
  return axios.post(url, params, {
    transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    responseType: 'blob',
    ...config
  }).then(async(data) => {
    const isBlob = blobValidate(data)
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text()
      const rspObj = JSON.parse(resText)
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg)
    }
    downloadLoadingInstance.close()
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close()
  })
}

export default axios
